<template>
  <div class="send-item-email container-fluid">
    <div class="row filter-row">
      <div class="col-12">
        <div class="title-component">{{title}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for>
            Seu nome
            <span class="required-field">*</span>
          </label>
          <input type="text" class="form-control" v-model="emailSend.own_name" />
        </div>
      </div>
      <div class="col-lg-8 col-12">
        <div class="form-group">
        <label for>
          Nome do destinatário
          <span class="required-field">*</span>
        </label>
        <input type="text" class="form-control" v-model="emailSend.send_name" />
      </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-group">
        <label for>
          Email do destinatário
          <span class="required-field">*</span>
        </label>
        <input type="text" class="form-control" v-model="emailSend.send_email" />
      </div>
      </div>
      <div class="col-12" v-if="message_field">
        <div class="form-group">
          <label for>Mensagem</label>
          <textarea v-model="emailSend.message" cols="30" rows="4" class="form-control"></textarea>
        </div>
      </div>
    </div>
    <div class="row row-send">
      <div class="col-12">
        <button class="btn btn-primary float-right" v-on:click="send()">Enviar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import email_send_validate from "@/imports/validator/models/email_send";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "send-item-email",
  props: {
    title: String,
    url: String,
    item_id: Number,
    message_field: Boolean
  },
  data() {
    return {
      emailSend: {}
    };
  },
  methods: {
    send: function() {
      let errors = validator.validate(
        this.emailSend,
        email_send_validate.model
      );

      if (errors.length == 0) {
        bus.$emit('changeLoading', true);
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/${this.url}/${this.item_id}`,
          this.emailSend
        );

        promise
          .then(response => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Email enviado com sucesso",
              icon: "success",
              onClose: () => {
                this.emailSend = {
                  own_name: "",
                  send_name: "",
                  send_email: ""
                };
              }
            });
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.send-item-email {
  padding: 0 !important;
  .title-component {
    font-size: 22px;
  }
  .row-send {
    margin-top: 12px;
  }
}
</style>